import React from 'react';

const PleaseActivateAccount = () => {
    return(<h3>Inactivated Account - please activate your account using the link sent to your email</h3>);
}

export default PleaseActivateAccount;